<template>
  <div class="lgrid-middle-noWrap">
    <template v-for="(filter, filterName) in contextualFilters">
      <button
        v-for="(value, key) in filter"
        :key="filterName+key"
        class="lcol-auto context-filter lgrid-middle-noWrap"
        @click="deleteStore(filterName, value.id)"
      >
        <span
          class="label lgrid-middle-noGutter"
          v-html="value.name"
        />
        <i class="dsio-close" />
      </button>
    </template>
  </div>
</template>

<script>
export default {
  computed: {
    contextualFilters () {
      return this.$store.getters[this.instanceId + '/Request/context'];
    },
  },
  methods: {
    deleteStore (filterId, value) {
      this.dispatch('removeValueFilter', { filterId, value });
    },
  },
};
</script>
